import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProductCatalogService} from '../../../orders/product-catalog/product-catalog.service';
import {ItemService} from '../item-list/item.service';
import {MessageService} from '../../../shared/message.service';
import { FormsModule } from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {CustomInput} from '../../../Components/input/custom-input';
import {Button} from '../../../Components/button/button';
import {CommonModule} from '@angular/common';
import {SpinnerOverlayService} from '../../../Components/spinner/spinner-overlay.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-item-add-relations',
  templateUrl: './item-add-relations.html',
  styleUrls: ['./item-add-relations.css'],
  imports: [CommonModule, FormsModule, CustomInput, Button, MatDialogModule]
})
export class ItemAddRelations implements OnInit {
  item: any | null = null;
  allRelatedItems: any[] = [];
  items: any[] = [];
  totalItems = 0;
  page = 0;
  rows = 6;
  first = 0;
  search: string = '';

  loading = false;

  constructor(
    public dialogRef: MatDialogRef<ItemAddRelations>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productCatalogService: ProductCatalogService,
    private itemService: ItemService,
    private messageService: MessageService,
    private spinner: SpinnerOverlayService
  ) {}

  ngOnInit(): void {
    const itemId = this.data?.itemId;
    if (!itemId) return;
    this.loadItem(itemId);
    this.loadAllRelated(itemId);
  }

  get startDisplay(): number {
    return this.totalItems === 0 ? 0 : this.first + 1;
  }

  get endDisplay(): number {
    return this.totalItems === 0 ? 0 : Math.min(this.first + this.rows, this.totalItems);
  }

  loadItem(itemId: string) {
    this.item = this.data?.item ?? null;
  }

  loadAllRelated(itemId: string) {
    this.handleLoading(true);
    const params: any = { itemIds: itemId, page: 0, size: 1000 };

    this.productCatalogService.findRelatedItemsByItemIds(params, 0).pipe(take(1)).subscribe({
      next: (resp: any) => {
        const list = resp.body?.items?.itemList ?? [];
        this.allRelatedItems = list.filter((i: any) => i.id !== this.data.itemId);
        this.applyFilter();
        this.handleLoading(false);
      },
      error: () => { this.handleLoading(false); }
    });
  }

  searchTriggered() {
    this.page = 0;
    this.first = 0;
    this.applyFilter();
  }

  clearSearch() {
    this.search = '';
    this.page = 0;
    this.first = 0;
    this.applyFilter();
  }

  private applyFilter() {
    const term = (this.search || '').trim().toLowerCase();
    if (!term) {
      this.items = this.allRelatedItems;
    } else {
      this.items = this.allRelatedItems.filter(i => {
        const id = (i.id || '').toLowerCase();
        const desc = (i.description || i.name || '').toLowerCase();
        return id.includes(term) || desc.includes(term);
      });
    }
    this.totalItems = this.items.length;
    this.updatePage();
  }

  private updatePage() {
    const start = this.page * this.rows;
    this.items = this.items.slice(start, start + this.rows);
    this.first = start;
  }

  changePage(delta: number) {
    const maxPage = Math.max(Math.ceil(this.totalItems / this.rows) - 1, 0);
    const nextPage = Math.min(Math.max(this.page + delta, 0), maxPage);
    if (nextPage === this.page) return;
    this.page = nextPage;
    this.applyFilter();
  }

  close() {
    this.dialogRef.close(false);
  }

  handleLoading(loading: boolean) {
    this.loading = loading;
    if (loading) this.spinner.show(); else this.spinner.hide();
  }

}
